/**
 * @generated SignedSource<<4ce82d4e75a6b5da5193e21377e5fe7e>>
 * @relayHash d321cd5e0129d4c98cd1bb4ba37d9417
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8dad03177fac86e43aed2bb5fcdab7ada5bbc8061618ff285c7ee00a093bfe3b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HubSetupQuery } from './HubSetupQuery.graphql';

const node: PreloadableConcreteRequest<HubSetupQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8dad03177fac86e43aed2bb5fcdab7ada5bbc8061618ff285c7ee00a093bfe3b",
    "metadata": {},
    "name": "HubSetupQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
